import { Route } from '@angular/router';
import { InitialDataResolver } from './app.resolvers';
import { AuthGuard, LayoutComponent, NoAuthGuard } from 'sting';
import { TwoFactorLoginModule } from '../../../../libs/sting/src/lib/auth/two-factor-login/two-factor-login.module';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
        data: { title: 'Sting' },
    },

    // Redirect signed in user
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'dashboard',
        data: { title: 'Sting' },
    },
    {
        path: 'changepass',
        loadChildren: () => import('libs/sting/src/lib/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule),
        data: { title: 'Sting' },
    },
    {
        path: 'confirmation-success',
        loadChildren: () => import('libs/sting/src/lib/auth/confirmation-success/confirmation-success.module').then(m => m.AuthConfirmationSuccessModule),
        data: { title: 'Sting' },
    },
    {
        path: 'pass-change-success',
        loadChildren: () => import('libs/sting/src/lib/auth/pass-change-success/pass-change-success.module').then(m => m.AuthPassChangeSuccessModule),
        data: { title: 'Sting' },
    },
    {
        path: 'confirmation-required',
        loadChildren: () => import('libs/sting/src/lib/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule),
        data: { title: 'Sting' },
    },
    {
        path: 'forgot-password',
        loadChildren: () => import('libs/sting/src/lib/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule),
        data: { title: 'Zapomenuté heslo | Sting' },
    },
    {
        path: 'newpass',
        loadChildren: () => import('libs/sting/src/lib/auth/new-password/new-password.module').then(m => m.AuthNewPasswordModule),
        data: { title: 'Nové heslo | Sting' },
    },
    {
        path: 'privacy',
        loadChildren: () => import('libs/sting/src/lib/pages/privacy/privacy.module').then(m => m.PrivacyModule),
        data: { title: 'Podmínky | Sting' },
    },
    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-in',
                loadChildren: () => import('libs/sting/src/lib/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule),
                data: { title: 'Přihášení | Sting' },
            },
            {
                path: 'two-factor',
                loadChildren: () => import('libs/sting/src/lib/auth/two-factor-login/two-factor-login.module').then(m => m.TwoFactorLoginModule),
                data: { title: 'Přihášení | Sting' },
            },
            {
                path: 'resend-link',
                loadChildren: () => import('libs/sting/src/lib/auth/resend-link/resend-link.module').then(m => m.AuthResetLinkModule),
                data: { title: 'Aktivace | Sting' },
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () => import('libs/sting/src/lib/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule),
                data: { title: 'Odhlášení | Sting' },
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,

        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'two-factor',
                loadChildren: () => import('libs/sting/src/lib/auth/two-factor-login/two-factor-login.module').then(m => m.TwoFactorLoginModule),
                data: { title: 'Přihášení | Sting' },
            },
            {
                path: 'users',
                loadChildren: () => import('libs/sting/src/lib/users/users.module').then(m => m.UsersModule),
                data: { title: 'Správa Uživatelů | Sting' },
            },
            {
                path: 'dashboard',
                loadChildren: () => import('libs/sting/src/lib/dashboard/project/project.module').then(m => m.ProjectModule),
                data: { title: 'Sting' },
            },
            {
                path: 'support',
                loadChildren: () => import('libs/sting/src/lib/pages/support/support.module').then(m => m.SupportModule),
                data: { title: 'Podpora | Sting' },
            },
            {
                path: 'changelog',
                loadChildren: () => import('libs/sting/src/lib/pages/changelog/changelog.module').then(m => m.ChangelogModule),
                data: { title: 'Sting' },
            },
            {
                path: 'profile',
                loadChildren: () => import('libs/sting/src/lib/profile/profile.module').then(m => m.ProfileModule),
                data: { title: 'Správa Profilu | Sting' },
            },
            {
                path: 'communications',
                loadChildren: () => import('libs/sting/src/lib/communications/communications.module').then(m => m.CommunicationsModule),
                data: { title: 'Notifikace | Sting' },
            },
            {
                path: 'news',
                loadChildren: () => import('libs/sting/src/lib/news/news.module').then(m => m.NewsModule),
                data: { title: 'Novinky | Sting' },
            },
            {
                path: 'forms',
                loadChildren: () => import('libs/sting/src/lib/forms/forms.module').then(m => m.StingFormsModule),
                data: { title: 'Listy | Sting' },
            },
            {
                path: 'companies',
                loadChildren: () => import('libs/sting/src/lib/companies/companies.module').then(m => m.CompaniesModule),
                data: { title: 'Firmy | Sting' },
            },
            {
                path: 'logs',
                loadChildren: () => import('libs/sting/src/lib/logs/logs.module').then(m => m.LogsModule),
                data: { title: 'Statistiky | Sting' },
            },
            {
                path: 'menu',
                loadChildren: () => import('libs/sting/src/lib/menu-items/menu-items.module').then(m => m.MenuItemsModule),
                data: { title: 'Položky menu | Sting' },
            },
            {
                path: 'groups',
                loadChildren: () => import('libs/sting/src/lib/groups/groups.module').then(m => m.GroupsModule),
                data: { title: 'Skupiny | Sting' },
            },
            {
                path: 'courses',
                loadChildren: () => import('libs/sting/src/lib/courses/courses.module').then(m => m.CoursesModule),
                data: { title: 'Školení | Sting' },
            },
            { path: 'flags', loadChildren: () => import('libs/sting/src/lib/flags/flags.module').then(m => m.FlagsModule) },

            {
                path: 'sign-privacy',
                loadChildren: () => import('libs/sting/src/lib/pages/privacy/privacy.module').then(m => m.PrivacyModule),
                data: { title: 'Podmínky | Sting' },
            },
            // maintenance, error & Catch all
            {
                path: 'maintenance',
                loadChildren: () => import('libs/sting/src/lib/pages/maintenance/maintenance.module').then(m => m.MaintenanceModule),
                data: { title: 'Sting' },
            },
            {
                path: '500-internal-server-error',
                loadChildren: () => import('libs/sting/src/lib/pages/error/error-500/error-500.module').then(m => m.Error500Module),
                data: { title: 'Sting' },
            },
            {
                path: '404-not-found',
                pathMatch: 'full',
                loadChildren: () => import('libs/sting/src/lib/pages/error/error-404/error-404.module').then(m => m.Error404Module),
                data: { title: '404 | Sting' },
            },
            {
                path: '**',
                redirectTo: '404-not-found',
                data: { title: '404 | Sting' },
            },
        ],
    },
];
